<template>
  <empty-layout>
    <div
      v-if="!loading"
      class="w-[100vw] h-[100svh] fixed top-0 left-0 right-0 bottom-0"
    >
      <div
        class="close-btn absolute cursor-pointer z-50 mx-2 md:mx-6 lg:ml-14 pt-2 md:pt-4"
        @click="back"
      >
        <img src="../../../public/assets/icons/go-back-chevron.svg" />
      </div>
      <iframe
        :src="prefilledFormUrl"
        id="JotFormIFrame-250500767303449"
        title="(Registration) GenerationS Implementation Community 2, 3, 4"
        onload="window.parent.scrollTo(0,0)"
        class="w-[100vw] h-[100svh] overflow-auto"
      ></iframe>
    </div>
    <div v-else>
      <loading-state></loading-state>
    </div>
  </empty-layout>
</template>

<script>
import EmptyLayout from "@/components/EmptyLayout.vue";
import { mapGetters, mapState } from "vuex";

export default {
  layout: "form-empty",
  components: {
    EmptyLayout,
  },
  data() {
    return {
      loading: false,
      formValues: {
        CH: "",
        CT: "",
        DID: 0,
      },
      baseFormUrl: "https://pci.jotform.com/252322956064457",
    };
  },
  async created() {
    this.loading = true;
    await Promise.all([
      this.$store.dispatch("profile/fetchProfile"),
      this.$store.dispatch("conference/fetchFormsSignup", 5),
    ]);
    this.loading = false;
  },
  computed: {
    ...mapGetters("profile", [
      "id",
      "name",
      "email",
      "country",
      "organization",
    ]),
    ...mapState("conference", ["formsSignup"]),
    hasSignup() {
      return this.formsSignup && this.formsSignup[5];
    },
    prefilledFormUrl() {
      if (!this.hasSignup) {
        // Assign Vuex getter values to formValues
        this.formValues.DID = this.id || 0;
        // this.formValues.FN1 = this.name || "";
        // this.formValues.EM1 = this.email || "";
        this.formValues.CH = this.organization || "";
        this.formValues.CT = this.country || "";
      }
      this.formValues.done = this.hasSignup ? 1 : 0;
      // Construct URL parameters
      const params = new URLSearchParams(this.formValues).toString();
      return `${this.baseFormUrl}?${params}`;
    },
  },
  methods: {
    back() {
      this.$router.push("/whats-next");
    },
  },
};
</script>
<style scoped>
iframe {
  background-color: #ffd900;
}
</style>
